<template>
  <div class="login-image pb-5 pt-5">
    <b-container class="h-100">
      <b-row align-h="center" align-v="center" class="h-75">
        <b-col cols="12" sm="12" md="6" lg="4" xl="4">
          <b-card class="mt-4">
            <b-form id="login-form" @keyup.enter="doLogin">
              <b-row align-h="center" class="mb-4">
                <i class="fas fa-user fa-5x login-logo c-green"></i>
              </b-row>
              <b-row align-h="center">
                <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                  <!-- User -->
                  <b-form-group>
                    <b-form-input v-model="input.username"
                                  autocomplete="current-username"
                                  id="input-username"
                                  :placeholder="$tc('message.user', 1)">
                    </b-form-input>
                    <i class="fas fa-user mt-2 form-icon c-green"></i>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                  <!-- Password -->
                  <b-form-group>
                    <b-form-input v-model="input.password"
                                  autocomplete="current-password"
                                  id="input-password"
                                  type="password"
                                  :placeholder="$t('message.password')">
                    </b-form-input>
                    <i class="fas fa-lock mt-2 form-icon c-green"></i>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row align-h="center">
                <b-col>
                  <b-button id="login-button" v-on:click="doLogin" class="w-100 b-c-green" :disabled="!input.username || !input.password">
                    {{$tc('message.login', 1)}}
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Login',
  data () {
    return {
      input: {}
    }
  },
  methods: {
    doLogin () {
      Vue.myLogin(this, this.input.username, this.input.password).then((response) => {
        if (response && response.data && response.data.token) {
          this.$root.$emit('loggedIn')
          Vue.success(this, `${this.$tc('message.login')} ${this.$tc('message.done', 1).toLowerCase()}`)
          this.checkPermissions(response.data.user)
        }
      }).catch(message => {
        console.log(message)
      })
    },
    checkPermissions (user) {
      /*
      let routes = Vue.getLocalStorage('routes')
      routes = routes ? JSON.parse(atob(routes)) : null
      const hasPermission = routes ? this.checkMapPermission(routes) : false
      const pushToMap = user.config.role === 'Admin' && hasPermission
      if (pushToMap) this.$router.push({ name: 'InteractiveMap' })
      */
      this.$router.push({ name: 'Home' })
    },
    checkMapPermission (routes) {
      let result = false
      routes.forEach(route => {
        // config[crud], create - read - update - delete
        if (route.path === '/map') result = route.config && route.config.r
        else if (route.child && route.child.length !== 0 && !result) result = this.checkMapPermission(route.child)
      })
      return result
    }
  }
}
</script>

<style scoped>
  .login-image {
    height: 100%;
    width: 100%;
    background-image: url('../../static/dimetior_home.jpg');
    background-color: #cccccc;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }

  .login-logo {
    border: 5px solid #249a80;
    border-radius: 100px;
    background: rgba(255, 255, 255, 0.6);
    width: 115px;
    height: 115px;
  }

  .login-logo::before{
    left: 18px;
    top: 10px;
    position: relative;
  }

  .form-icon {
    position: absolute;
    top: 2px;
    left: 28px;
  }

  #input-username, #input-password {
    padding-left: 40px;
  }

  .card {
    background: rgba(255, 255, 255, 0.6);
  }
</style>
